define('helper-component-getContent',['exports', './component--get-content-array.es', './component--parse-content.es'], function (exports, _componentGetContentArray, _componentParseContent) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _componentGetContentArray2 = _interopRequireDefault(_componentGetContentArray);

    var _componentParseContent2 = _interopRequireDefault(_componentParseContent);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    exports.default = function (componentsJSON, s) {
        var arr = (0, _componentGetContentArray2.default)(componentsJSON, s),
            res = {},
            content = {};

        if (!arr.length) {
            return {};
        }

        if (arr.length === 1) {
            return (0, _componentParseContent2.default)(arr[0]);
        }

        for (var i = 0; i < arr.length; i++) {
            content = (0, _componentParseContent2.default)(arr[i]);

            for (var key in content) {
                if (res.hasOwnProperty(key)) {
                    res[key].push(content[key]);
                } else {
                    res[key] = [content[key]];
                }
            }
        }

        return res;
    };
});
